import { config } from '../config.js';
import { getApiToken, OfflineError } from '../auth/msal.js';

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.message || `Request failed (${status})`);
    this.status = status;
    this.code = body?.error;
  }
}

// fetch wrapper: adds the token, turns failures into OfflineError (network)
// or ApiError (server said no).
//   raw: a Blob sent as-is (e.g. a photo) instead of a JSON body.
//   as: 'blob' to read the reply as a Blob (e.g. a photo).
export async function api(path, { method = 'GET', body, raw, as, signal } = {}) {
  const token = await getApiToken();
  let res;
  try {
    res = await fetch(`${config.apiBase}/api${path}`, {
      method,
      signal,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
        ...(raw ? { 'Content-Type': raw.type || 'application/octet-stream' } : {}),
      },
      body: raw || (body !== undefined ? JSON.stringify(body) : undefined),
    });
  } catch (e) {
    if (e.name === 'AbortError') throw e;
    throw new OfflineError();
  }
  if (as === 'blob' && res.ok) return res.blob();
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}
